// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/ppgatwick-ultra-light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/ppgatwick-bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/ppgatwick-jetextra-light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/ppgatwick-gliderextra-light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/ppgatwick-jumbosemi-bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/ppgatwick-jumboextra-light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("assets/imgs/grid-black.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("assets/imgs/bg-light.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'ppgatwick';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
}
@font-face {
  font-family: 'ppgatwick-bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
}
@font-face {
  font-family: 'ppgatwick-jetextralight';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
}
@font-face {
  font-family: 'ppgatwick-gliderextralight';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('opentype');
}
@font-face {
  font-family: 'ppgatwick-jumbosemi-bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('opentype');
}
@font-face {
  font-family: 'ppgatwick-jumboextra-light';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('opentype');
}
:root {
  --font-ppgatwick: 'ppgatwick', sans-serif;
  --font-ppgatwick-bold: 'ppgatwick-bold', sans-serif;
  --font-ppgatwick-jetextralight: 'ppgatwick-jetextralight', sans-serif;
  --font-ppgatwick-gliderextralight: 'ppgatwick-gliderextralight', sans-serif;
  --font-ppgatwick-jumbosemi-bold: 'ppgatwick-jumbosemi-bold', sans-serif;
  --font-ppgatwick-jumboextra-light: 'ppgatwick-jumboextra-light', sans-serif;
}
html[data-lang='vi'] {
  --font-ppgatwick: 'ppgatwick-jetextralight', sans-serif;
  --font-ppgatwick-bold: 'ppgatwick-bold', sans-serif;
  --font-ppgatwick-jetextralight: 'ppgatwick-jetextralight', sans-serif;
  --font-ppgatwick-gliderextralight: 'ppgatwick-gliderextralight', sans-serif;
  --font-ppgatwick-jumbosemi-bold: 'ppgatwick-jumbosemi-bold', sans-serif;
  --font-ppgatwick-jumboextra-light: 'ppgatwick-jumboextra-light', sans-serif;
}
.baseLayoutContainer__J3N1ale2Mv {
  --font-color: #e9e9d7;
  font-family: var(--font-ppgatwick);
  width: 100%;
  min-height: 100vh;
  min-width: 1200px;
  color: var(--font-color);
}
.baseLayoutContainer__J3N1ale2Mv.info-page__rkXxARu41p {
  --font-color: #0a141e;
}
.baseLayoutContainer__J3N1ale2Mv.advertisement-page__wq92AzPUl9 .baseLayout__aIwfM9aHST .ant-layout-content > div {
  padding: 0;
}
.baseLayoutContainer__J3N1ale2Mv .baseLayout__aIwfM9aHST {
  max-width: 1920px;
  margin: 0 auto;
  background-color: transparent;
  min-height: 100vh;
}
.baseLayoutContainer__J3N1ale2Mv .baseLayout__aIwfM9aHST .ant-layout-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.baseLayoutContainer__J3N1ale2Mv .baseLayout__aIwfM9aHST .ant-layout-content > div {
  position: relative;
  padding: 0 1.35rem;
  flex: 1;
}
.baseLayoutContainer__J3N1ale2Mv .baseLayout__aIwfM9aHST .logo__hbAAQu56Ba {
  display: flex;
  align-items: center;
}
.baseLayoutContainer__J3N1ale2Mv .baseLayout__aIwfM9aHST .headerMenu__aATvACR0C1 {
  flex: 1;
  padding: 0 20px;
}
.baseLayoutContainer__J3N1ale2Mv .header__alhX9yNqOA {
  position: fixed;
  z-index: 200;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0.61rem 0 0.2rem 0 !important;
  height: 0.89rem;
  background: transparent;
  color: var(--font-color);
  box-sizing: content-box;
  transition: all 0.15s;
}
.baseLayoutContainer__J3N1ale2Mv .header__alhX9yNqOA.isScroll__Bt0V9XaX9b {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) repeat-y top center / 100%, url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat center top / cover;
}
.baseLayoutContainer__J3N1ale2Mv .header__alhX9yNqOA .headerContent__yNTu658DoF {
  max-width: 1920px;
  padding: 0 0.76rem;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.baseLayoutContainer__J3N1ale2Mv .header__alhX9yNqOA .headerActions__TAC0xGOQDi {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}
.baseLayoutContainer__J3N1ale2Mv .header__alhX9yNqOA .languageDropdown__gLq7PSbH8r {
  position: relative;
}
.baseLayoutContainer__J3N1ale2Mv .header__alhX9yNqOA .languageToggle__wUde0aYvxd {
  display: inline-flex;
  align-items: center;
  gap: 0.08rem;
  border: none;
  border-radius: 0;
  background: transparent;
  color: var(--font-color);
  font-size: 0.18rem;
  padding: 0;
  cursor: pointer;
  opacity: 0.85;
  transition: opacity 0.2s;
}
.baseLayoutContainer__J3N1ale2Mv .header__alhX9yNqOA .languageToggle__wUde0aYvxd:hover {
  opacity: 1;
}
.baseLayoutContainer__J3N1ale2Mv .header__alhX9yNqOA .languageIcon__dPCCBhV6bS {
  transition: transform 0.2s ease;
}
.baseLayoutContainer__J3N1ale2Mv .header__alhX9yNqOA .languageIconOpen__VNtZWmir3V {
  transform: rotate(180deg);
}
.baseLayoutContainer__J3N1ale2Mv .header__alhX9yNqOA .languageOptions__VF1sctWyLQ {
  position: absolute;
  top: calc(100% + 0.08rem);
  right: 0;
  background: rgba(10, 20, 30, 0.82);
  border-radius: 0.08rem;
  min-width: 1.2rem;
  padding: 0.08rem 0;
  backdrop-filter: blur(6px);
  z-index: 12;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(10, 20, 30, 0.35);
}
.baseLayoutContainer__J3N1ale2Mv .header__alhX9yNqOA .languageOption__ytQqtaLqBr {
  border: none;
  background: transparent;
  color: var(--font-color);
  font-size: 0.16rem;
  padding: 0.04rem 0.18rem;
  text-align: left;
  cursor: pointer;
  opacity: 0.75;
  transition: opacity 0.2s;
}
.baseLayoutContainer__J3N1ale2Mv .header__alhX9yNqOA .languageOption__ytQqtaLqBr:hover {
  opacity: 1;
}
.baseLayoutContainer__J3N1ale2Mv .header__alhX9yNqOA .languageOptionActive__d6y3RoaNvd {
  font-weight: 600;
  opacity: 1;
}
.baseLayoutContainer__J3N1ale2Mv .header__alhX9yNqOA span {
  font-size: 0.22rem;
  margin-right: 0.15rem;
}
.baseLayoutContainer__J3N1ale2Mv .sideLayout__CZdsS6FE_z {
  height: 100vh;
}
.baseLayoutContainer__J3N1ale2Mv .sideLayout__CZdsS6FE_z .logo__hbAAQu56Ba {
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.baseLayoutContainer__J3N1ale2Mv .sideLayout__CZdsS6FE_z .headerMenu__aATvACR0C1 {
  border-right: none;
  background: transparent;
}
.baseLayoutContainer__J3N1ale2Mv .sideLayout__CZdsS6FE_z .headerMenu__aATvACR0C1 li::after {
  border: none;
}
.baseLayoutContainer__J3N1ale2Mv .sideLayout__CZdsS6FE_z .siteLayout___kIMNfSLXE .icon__op4IHl7KXk svg {
  width: 20px;
  height: 20px;
}
.baseLayoutContainer__J3N1ale2Mv .sideLayout__CZdsS6FE_z .ant-image {
  width: 120px;
}
.baseLayoutContainer__J3N1ale2Mv .sideLayout__CZdsS6FE_z .ant-menu-item a {
  color: #fff;
}
.baseLayoutContainer__J3N1ale2Mv .sideLayout__CZdsS6FE_z .ant-menu-item-selected {
  background: #04cb94 !important;
}
.baseLayoutContainer__J3N1ale2Mv .sideLayout__CZdsS6FE_z .ant-layout-content {
  margin: 10px;
  padding: 20px;
  background-color: #fff;
}
.baseLayoutContainer__J3N1ale2Mv.info-page__rkXxARu41p .header__alhX9yNqOA .languageToggle__wUde0aYvxd {
  opacity: 0.75;
}
.baseLayoutContainer__J3N1ale2Mv.info-page__rkXxARu41p .header__alhX9yNqOA .languageOptions__VF1sctWyLQ {
  background: rgba(233, 233, 215, 0.92);
  box-shadow: 0 4px 12px rgba(10, 20, 30, 0.15);
}
.baseLayoutContainer__J3N1ale2Mv.info-page__rkXxARu41p .header__alhX9yNqOA .languageOption__ytQqtaLqBr {
  color: #0a141e;
  opacity: 0.7;
}
.baseLayoutContainer__J3N1ale2Mv.info-page__rkXxARu41p .header__alhX9yNqOA .languageOption__ytQqtaLqBr:hover,
.baseLayoutContainer__J3N1ale2Mv.info-page__rkXxARu41p .header__alhX9yNqOA .languageOptionActive__d6y3RoaNvd {
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/fonts.less","webpack://./src/components/BaseLayout/index.module.less"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,+DAAA;ACCF;ADEA;EACE,6BAAA;EACA,+DAAA;ACAF;ADGA;EACE,sCAAA;EACA,+DAAA;ACDF;ADIA;EACE,yCAAA;EACA,+DAAA;ACFF;ADKA;EACE,uCAAA;EACA,+DAAA;ACHF;ADMA;EACE,yCAAA;EACA,+DAAA;ACJF;ADeA;EACE,yCAAA;EACA,mDAAA;EACA,qEAAA;EACA,2EAAA;EACA,uEAAA;EACA,2EAAA;ACbF;ADiBA;EACE,uDAAA;EACA,mDAAA;EACA,qEAAA;EACA,2EAAA;EACA,uEAAA;EACA,2EAAA;ACfF;AApCA;EACE,qBAAA;EAEA,kCAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,wBAAA;AAqCF;AA/BE;EAEE,qBAAA;AAgCJ;AA3BE;EAMU,UAAA;AAwBZ;AAlDA;EAqCI,iBAAA;EAEA,cAAA;EACA,6BAAA;EACA,iBAAA;AAeJ;AAxDA;EA6CQ,OAAA;EAEA,aAAA;EACA,sBAAA;AAaR;AA7DA;EAsDU,kBAAA;EACA,kBAAA;EACA,OAAA;AAUV;AAlEA;EA8DM,aAAA;EACA,mBAAA;AAON;AAtEA;EAmEM,OAAA;EACA,eAAA;AAMN;AA1EA;EAyEI,eAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,sCAAA;EACA,eAAA;EACA,uBAAA;EACA,wBAAA;EACA,uBAAA;EACA,qBAAA;AAIJ;AAFI;EAGE,oJAAA;AAEN;AA1FA;EA6FM,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AAAN;AAnGA;EAuGM,aAAA;EACA,mBAAA;EACA,WAAA;AADN;AAxGA;EA6GM,kBAAA;AAFN;AA3GA;EAiHM,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,wBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;AAHN;AAzHA;EAgIM,UAAA;AAJN;AA5HA;EAoIM,+BAAA;AALN;AA/HA;EAwIM,yBAAA;AANN;AAlIA;EA4IM,kBAAA;EACA,yBAAA;EACA,QAAA;EACA,kCAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,6CAAA;AAPN;AAjJA;EA4JM,YAAA;EACA,uBAAA;EACA,wBAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;AARN;AA5JA;EAwKM,UAAA;AATN;AA/JA;EA4KM,gBAAA;EACA,UAAA;AAVN;AAnKA;EAiLM,kBAAA;EACA,qBAAA;AAXN;AAvKA;EAuLI,aAAA;AAbJ;AA1KA;EA0LM,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAbN;AAjLA;EAkMM,kBAAA;EACA,uBAAA;AAdN;AArLA;EAsMQ,YAAA;AAdR;AAxLA;EA4MQ,WAAA;EACA,YAAA;AAjBR;AA5LA;EAmNQ,YAAA;AApBR;AA/LA;EAuNQ,WAAA;AArBR;AAlMA;EA2NQ,8BAAA;AAtBR;AArMA;EA+NQ,YAAA;EACA,aAAA;EACA,sBAAA;AAvBR;AA4BE;EAGM,aAAA;AA5BR;AAyBE;EAOM,qCAAA;EACA,6CAAA;AA7BR;AAqBE;EAYM,cAAA;EACA,YAAA;AA9BR;AAiBE;;EAkBM,UAAA;AA/BR","sourcesContent":["@font-face {\n  font-family: 'ppgatwick';\n  src: url('../fonts/ppgatwick-ultra-light.otf') format('opentype');\n}\n\n@font-face {\n  font-family: 'ppgatwick-bold';\n  src: url('../fonts/ppgatwick-bold.otf') format('opentype');\n}\n\n@font-face {\n  font-family: 'ppgatwick-jetextralight';\n  src: url('../fonts/ppgatwick-jetextra-light.otf') format('opentype');\n}\n\n@font-face {\n  font-family: 'ppgatwick-gliderextralight';\n  src: url('../fonts/ppgatwick-gliderextra-light.otf') format('opentype');\n}\n\n@font-face {\n  font-family: 'ppgatwick-jumbosemi-bold';\n  src: url('../fonts/ppgatwick-jumbosemi-bold.otf') format('opentype');\n}\n\n@font-face {\n  font-family: 'ppgatwick-jumboextra-light';\n  src: url('../fonts/ppgatwick-jumboextra-light.otf') format('opentype');\n}\n\n// ============================================\n// CSS 变量定义 - 用于字体切换\n// ============================================\n\n// 系统字体回退\n@system-font: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;\n\n// 默认使用自定义字体的 CSS 变量\n:root {\n  --font-ppgatwick: 'ppgatwick', sans-serif;\n  --font-ppgatwick-bold: 'ppgatwick-bold', sans-serif;\n  --font-ppgatwick-jetextralight: 'ppgatwick-jetextralight', sans-serif;\n  --font-ppgatwick-gliderextralight: 'ppgatwick-gliderextralight', sans-serif;\n  --font-ppgatwick-jumbosemi-bold: 'ppgatwick-jumbosemi-bold', sans-serif;\n  --font-ppgatwick-jumboextra-light: 'ppgatwick-jumboextra-light', sans-serif;\n}\n\n// 越南语使用系统字体（ppgatwick 不支持越南语特殊字符）\nhtml[data-lang='vi'] {\n  --font-ppgatwick: 'ppgatwick-jetextralight', sans-serif;\n  --font-ppgatwick-bold: 'ppgatwick-bold', sans-serif;\n  --font-ppgatwick-jetextralight: 'ppgatwick-jetextralight', sans-serif;\n  --font-ppgatwick-gliderextralight: 'ppgatwick-gliderextralight', sans-serif;\n  --font-ppgatwick-jumbosemi-bold: 'ppgatwick-jumbosemi-bold', sans-serif;\n  --font-ppgatwick-jumboextra-light: 'ppgatwick-jumboextra-light', sans-serif;\n}\n","@import 'assets/styles/variables.less';\n@import 'assets/styles/fonts.less';\n\n.baseLayoutContainer {\n  --font-color: @color_white;\n\n  font-family: var(--font-ppgatwick);\n  width: 100%;\n  min-height: 100vh;\n  min-width: @pageMiniWidth;\n  color: var(--font-color);\n  // background: url('assets/imgs/grid.png') repeat-y center center / 100% auto,\n  //   url('assets/imgs/home_bg.png') no-repeat center center / cover;\n  // #070f58\n  // background: url('assets/imgs/grid.png') repeat-y center center / 100%;\n\n  &.info-page {\n    // 白色主题\n    --font-color: @color_black;\n\n    // background: url('assets/imgs/grid-black.png') repeat-y center center / 100%;\n  }\n\n  &.advertisement-page {\n    // 广告页面 - 移除内容区域的左右 padding\n    .baseLayout {\n      :global {\n        .ant-layout-content {\n          > div {\n            padding: 0;\n          }\n        }\n      }\n    }\n  }\n\n  // overflow-x: hidden;\n\n  .baseLayout {\n    //  height: 100vh;\n    max-width: @pageMaxWidth;\n    // padding: 0 @pagePadding;\n    margin: 0 auto;\n    background-color: transparent;\n    min-height: 100vh;\n\n    :global {\n      .ant-layout-content {\n        flex: 1;\n\n        display: flex;\n        flex-direction: column;\n\n        // padding: 0 70px;\n        // margin: 10px;\n        // background-color: #fff;\n        > div {\n          position: relative;\n          padding: 0 1.35rem;\n          flex: 1;\n        }\n      }\n    }\n\n    .logo {\n      display: flex;\n      align-items: center;\n    }\n\n    .headerMenu {\n      flex: 1;\n      padding: 0 20px;\n    }\n  }\n\n  .header {\n    position: fixed;\n    z-index: 200;\n    top: 0;\n    left: 0;\n    width: 100%;\n    padding: @headerTopHeight 0 0.2rem 0 !important;\n    height: @headerHeight;\n    background: transparent;\n    color: var(--font-color);\n    box-sizing: content-box;\n    transition: all 0.15s;\n\n    &.isScroll {\n      // background: linear-gradient(to bottom, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n      // backdrop-filter: blur(10px);\n      background: url('assets/imgs/grid-black.png') repeat-y top center / 100%,\n        url('assets/imgs/bg-light.png') no-repeat center top / cover;\n    }\n\n    .headerContent {\n      max-width: @pageMaxWidth;\n      padding: 0 @pagePadding;\n      margin: 0 auto;\n      display: flex;\n      align-items: center;\n      flex-direction: row;\n      justify-content: space-between;\n    }\n\n    .headerActions {\n      display: flex;\n      align-items: center;\n      gap: 0.3rem;\n    }\n\n    .languageDropdown {\n      position: relative;\n    }\n\n    .languageToggle {\n      display: inline-flex;\n      align-items: center;\n      gap: 0.08rem;\n      border: none;\n      border-radius: 0;\n      background: transparent;\n      color: var(--font-color);\n      font-size: 0.18rem;\n      padding: 0;\n      cursor: pointer;\n      opacity: 0.85;\n      transition: opacity 0.2s;\n    }\n\n    .languageToggle:hover {\n      opacity: 1;\n    }\n\n    .languageIcon {\n      transition: transform 0.2s ease;\n    }\n\n    .languageIconOpen {\n      transform: rotate(180deg);\n    }\n\n    .languageOptions {\n      position: absolute;\n      top: calc(100% + 0.08rem);\n      right: 0;\n      background: fade(@color_black, 82%);\n      border-radius: 0.08rem;\n      min-width: 1.2rem;\n      padding: 0.08rem 0;\n      backdrop-filter: blur(6px);\n      z-index: 12;\n      display: flex;\n      flex-direction: column;\n      overflow: hidden;\n      box-shadow: 0 4px 12px fade(@color_black, 35%);\n    }\n\n    .languageOption {\n      border: none;\n      background: transparent;\n      color: var(--font-color);\n      font-size: 0.16rem;\n      padding: 0.04rem 0.18rem;\n      text-align: left;\n      cursor: pointer;\n      opacity: 0.75;\n      transition: opacity 0.2s;\n    }\n\n    .languageOption:hover {\n      opacity: 1;\n    }\n\n    .languageOptionActive {\n      font-weight: 600;\n      opacity: 1;\n    }\n\n    span {\n      font-size: 0.22rem;\n      margin-right: 0.15rem;\n    }\n  }\n\n  .sideLayout {\n    height: 100vh;\n\n    .logo {\n      width: 100%;\n      height: 64px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .headerMenu {\n      border-right: none;\n      background: transparent;\n\n      li::after {\n        border: none;\n      }\n    }\n\n    .siteLayout {\n      .icon svg {\n        width: 20px;\n        height: 20px;\n      }\n    }\n\n    :global {\n      .ant-image {\n        width: 120px;\n      }\n\n      .ant-menu-item a {\n        color: #fff;\n      }\n\n      .ant-menu-item-selected {\n        background: #04cb94 !important;\n      }\n\n      .ant-layout-content {\n        margin: 10px;\n        padding: 20px;\n        background-color: #fff;\n      }\n    }\n  }\n\n  &.info-page {\n    .header {\n      .languageToggle {\n        opacity: 0.75;\n      }\n\n      .languageOptions {\n        background: fade(@color_white, 92%);\n        box-shadow: 0 4px 12px fade(@color_black, 15%);\n      }\n\n      .languageOption {\n        color: @color_black;\n        opacity: 0.7;\n      }\n\n      .languageOption:hover,\n      .languageOptionActive {\n        opacity: 1;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"baseLayoutContainer": `baseLayoutContainer__J3N1ale2Mv`,
	"info-page": `info-page__rkXxARu41p`,
	"advertisement-page": `advertisement-page__wq92AzPUl9`,
	"baseLayout": `baseLayout__aIwfM9aHST`,
	"logo": `logo__hbAAQu56Ba`,
	"headerMenu": `headerMenu__aATvACR0C1`,
	"header": `header__alhX9yNqOA`,
	"isScroll": `isScroll__Bt0V9XaX9b`,
	"headerContent": `headerContent__yNTu658DoF`,
	"headerActions": `headerActions__TAC0xGOQDi`,
	"languageDropdown": `languageDropdown__gLq7PSbH8r`,
	"languageToggle": `languageToggle__wUde0aYvxd`,
	"languageIcon": `languageIcon__dPCCBhV6bS`,
	"languageIconOpen": `languageIconOpen__VNtZWmir3V`,
	"languageOptions": `languageOptions__VF1sctWyLQ`,
	"languageOption": `languageOption__ytQqtaLqBr`,
	"languageOptionActive": `languageOptionActive__d6y3RoaNvd`,
	"sideLayout": `sideLayout__CZdsS6FE_z`,
	"siteLayout": `siteLayout___kIMNfSLXE`,
	"icon": `icon__op4IHl7KXk`
};
export default ___CSS_LOADER_EXPORT___;
